/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_NewInputs */

const vi_tea_lot_new = /** @type {(inputs: Tea_Lot_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô chè`)
};

/**

* @param {Tea_Lot_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_new = /** @type {((inputs?: Tea_Lot_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_new(inputs)
});